import { TCreateConverter, TFetchConverter } from '../types/converter.types';
import {
  TSsoConfigurationDB,
  TSsoConfigurationUI,
  TSsoConfigureDB,
  TSsoConfigureUI,
} from '../types/sso.types';

export const ssoConfigurationConverter: TFetchConverter<TSsoConfigurationUI, TSsoConfigurationDB> = {
  fromDb: (data) => ({
    identityProviderName: data.identityProviderName,
    isEnabled: data.isEnabled ?? true,
  }),
};

export const ssoConfigureConverter: TCreateConverter<TSsoConfigureUI, TSsoConfigureDB> = {
  toDb: (data) => ({
    clientId: data.clientId,
    clientSecret: data.clientSecret,
    tenantId: data.tenantId,
  }),
};
